import store from "@/store";

const showCardArr = (agentinfo) => {
  let isCardSwitch = store.state.isCardSwitch;
  let $t = window.$t;
  let cardArr = [];
  let arr = {
    blance: {
      id: 0,
      title: $t("ptt_card"),
      num: agentinfo.blance,
      bool: true,
      //根据项目是否显示
    },
    recording_card: {
      id: 1,
      title: $t("recording_card"),
      num: agentinfo.recording_card,
      bool: true,
    },
    location_card: {
      id: 2,
      title: $t("gps_card"),
      num: agentinfo.location_card,
      bool: true,
    },
    sos_card: {
      id: 3,
      title: $t("sos_card"),
      num: agentinfo.sos_card,
      bool: true,
    },
    enclosure_card: {
      id: 4,
      title: $t("bounding_card"),
      num: agentinfo.enclosure_card,
      bool: true,
    },
    // 'video_card': {
    //   id: 5,
    //   title: $t("video_card"),
    //   num: agentinfo.video_card
    // },
    voice_position_card: {
      id: 8,
      title: $t("PTTGPS"),
      num: agentinfo.voice_position_card,
      bool: window.XINPOC_WEB_CONFIG.isProject == "yuantong" ? true : false,
    },
    duplex_card: {
      id: 6,
      title: $t("duplex_card"),
      num: agentinfo.duplex_card,
      bool: true,
    },
    super_card: {
      id: 7,
      title: $t("vipcard"),
      num: agentinfo.super_card,
      bool: true,
    },
    // patrol_card: {
    //   id: 9,
    //   title: $t('userPatrol.PatrolCard'),
    //   num: agentinfo.patrol_card,
    //   bool: true,
    // }
  };
  for (const key in arr) {
    if (!isCardSwitch && arr[key] && arr[key].bool) {
      cardArr.push(arr[key]);
    } else {
      if (arr[key].bool && isCardSwitch[key] == 1) {
        cardArr.push(arr[key]);
      }
    }
  }

  return cardArr;
};

const showCardArrUser = () => {
  let isCardSwitch = store.state.isCardSwitch;
  let $t = window.$t;
  let cardArr = [];
  let arr = {
    // 'blance': {
    //   id: 0,
    //   title: $t("ptt_card"),
    // },
    recording_card: {
      id: 1,
      title: $t("recordingcardrecycling"),
    },
    location_card: {
      id: 2,
      title: $t("LocationCardRecycling"),
    },
    // 'sos_card': {
    //   id: 3,
    //   title: $t("SOSCardRecycling"),
    // },
    enclosure_card: {
      id: 4,
      title: $t("FenceCardRecycling"),
    },
    // 'video_card': {
    //   id: 5,
    //   title: $t("videocardrecycling"),
    // },
    duplex_card: {
      id: 6,
      title: $t("Duplexcardrecycling"),
    },
    // 'super_card': {
    //   id: 7,
    //   title: $t("vipcard")
    // },
    // patrol_card: {
    //   id: 9,
    //   title: $t('userPatrol.GuardCardRecycling'),
    // },
  };
  for (const key in arr) {
    if (!isCardSwitch) {
      cardArr.push(arr[key]);
    } else {
      if (isCardSwitch[key] == 1) {
        cardArr.push(arr[key]);
      }
    }
  }

  return cardArr;
};

const showCardService = () => {
  let isCardSwitch = store.state.isCardSwitch;
  let $t = window.$t;
  let cardArr = [];
  let arr = {
    recording_card: {
      id: 1,
      title: $t("recordingservice"),
    },
    location_card: {
      id: 2,
      title: $t("locationservice"),
    },
    sos_card: {
      id: 3,
      title: $t("SOSservice"),
    },
    enclosure_card: {
      id: 4,
      title: $t("fenceservice"),
    },
    // 'video_card': {
    //   id: 5,
    //   title: $t("videoservice"),
    // },
    duplex_card: {
      id: 6,
      title: $t("duplexservice"),
    },
    // patrol_card: {
    //   id: 9,
    //   title: $t('userPatrol.patrolService'),
    // },
  };
  for (const key in arr) {
    if (!isCardSwitch) {
      cardArr.push(arr[key]);
    } else {
      if (isCardSwitch[key] == 1) {
        cardArr.push(arr[key]);
      }
    }
  }

  return cardArr;
};

const filterCardShow = (type) => {
  //过滤卡显示
  let isCardSwitch = store.state.isCardSwitch;
  let $t = window.$t;
  let cardArr = [];
  let arr = {
    blance: {
      id: 0,
      key: "blance",
      isBool: 1,
      title: $t("is_card.ptt"),
    },
    recording_card: {
      id: 1,
      key: "recording_card",
      isBool: 1,
      title: $t("is_card.recording"),
    },
    location_card: {
      id: 2,
      key: "location_card",
      isBool: 1,
      title: $t("is_card.gps"),
    },
    sos_card: {
      id: 3,
      key: "sos_card",
      isBool: 1,
      title: $t("is_card.sos"),
    },
    enclosure_card: {
      id: 4,
      key: "enclosure_card",
      isBool: 1,
      title: $t("is_card.bounding"),
    },
    // 'video_card': {
    //   id: 5,
    //   isBool: 1,
    //   title: $t("video_card"),
    // },
    duplex_card: {
      id: 6,
      key: "duplex_card",
      isBool: 1,
      title: $t("is_card.duplex"),
    },
    super_card: {
      id: 7,
      key: "super_card",
      isBool: 1,
      title: $t("is_card.vip"),
    },
    // patrol_card: {
    //   id: 9,
    //   key: "patrol_card",
    //   isBool: 1,
    //   title: $t('userPatrol.Patrol'),
    // },
  };
  for (const key in arr) {
    if (!isCardSwitch) {
      cardArr.push(arr[key]);
    } else {
      if (isCardSwitch[key] == 1) {
        cardArr.push(arr[key]);
      }
    }
  }

  return type == 1 ? arr : cardArr;
};

const filterCardShowTow = (type) => {
  //过滤卡显示
  let isCardSwitch = store.state.isCardSwitch;
  let $t = window.$t;
  let cardArr = [];
  let show = $t("show");
  let arr = {
    blance: {
      id: 0,
      key: "blance",
      isBool: 1,
      title: show + $t("ptt_card"),
    },
    recording_card: {
      id: 1,
      key: "recording_card",
      isBool: 1,
      title: show + $t("recording_card"),
    },
    location_card: {
      id: 2,
      key: "location_card",
      isBool: 1,
      title: show + $t("gps_card"),
    },
    sos_card: {
      id: 3,
      key: "sos_card",
      isBool: 1,
      title: show + $t("sos_card"),
    },
    enclosure_card: {
      id: 4,
      key: "enclosure_card",
      isBool: 1,
      title: show + $t("bounding_card"),
    },
    // 'video_card': {
    //   id: 5,
    //   isBool: 1,
    //   title: show+$t("video_card"),
    // },
    duplex_card: {
      id: 6,
      key: "duplex_card",
      isBool: 1,
      title: show + $t("duplex_card"),
    },
    super_card: {
      id: 7,
      key: "super_card",
      isBool: 1,
      title: show + $t("vipcard"),
    },
    // patrol_card: {
    //   id: 9,
    //   key: "patrol_card",
    //   isBool: 1,
    //   title: show + $t('userPatrol.PatrolCard'),
    // },
  };
  for (const key in arr) {
    if (!isCardSwitch) {
      cardArr.push(arr[key]);
    } else {
      if (isCardSwitch[key] == 1) {
        cardArr.push(arr[key]);
      }
    }
  }

  return type == 1 ? arr : cardArr;
};

const isShowCard = (key) => {
  let arr = store.state.isCardSwitch;
  let bool = store.state.pathmini.length <= 4;
  if (!bool && arr && arr[key] && arr[key] == 1) {
    bool = true;
  }
  return bool;
};

const isCardType = (type) => {
  //是否显示卡类型
  let bool = false;
  if (store.state.pathmini.length > 4) {
    let arr = JSON.parse(JSON.stringify(store.state.isCardSwitch));
    if (arr["path"]) {
      delete arr["path"];
    }
    for (const key in arr) {
      if (key != "super_card" && key != "video_card") {
        if (type == 1) {
          if (arr["super_card"] == 1 && arr["blance"] == 1) {
            //判断VIP卡和其他卡是否都有选择
            bool = true;
          }
        } else if (type == 2) {
          if (
            (arr["super_card"] == 0 && arr["blance"] == 1) ||
            (arr["super_card"] == 1 && arr["blance"] == 1)
          ) {
            //判断VIP卡和语音卡是否都有选择或者vip卡没选择
            bool = true;
          }
        }
      }
    }
  } else {
    bool = true;
  }
  return bool;
};

export default {
  showCardArr,
  isShowCard,
  filterCardShow,
  isCardType,
  showCardArrUser,
  showCardService,
  filterCardShowTow,
};
